// removed by extract-text-webpack-plugin
module.exports = {"binary_menu":"_3qOIISSwuaIqTx7pUVp-s1","binary_menu_item":"_1-O6NI47tapRiSWnJDxuUK","binary_menu_item_child":"_36zJ1IkhVpXIXmk3_xX1l","binary_menu_divider":"_1KDKem9kW4defBOh9ffG2l","binary_menu_item_nested":"_21aSki5HKgmHdEz2g59JLb"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryMenu/BinaryMenu.scss
// module id = 2243
// module chunks = 1